import { createFileRoute } from '@tanstack/react-router';
import { TracksPage } from '@/page/TracksPage';

export const Route = createFileRoute('/_app/admin/tracks/')({ component: TracksPage });
